export class OtdsError {
  id: number;

  nombreDeArchivo: string;

  fecProceso: Date;

  origen: string | null;

  nroRemito: string | null;

  ptoEmision: string | null;

  codDestino: string | null;

  tpreError: string | null;

  transporte: string | null;

  vinLetras: string | null;

  vinNumeros: number | null;

  vin: string | null;

  error: string | null;

  esReprocesado: boolean;

  isChecked: boolean = false;

  lineNum: number | null;

  canBeReprocessed: boolean;

  isArchiveProcessing: boolean = false;
  isReprocessProcessing: boolean = false;

  get isProcessing(): boolean {
    return this.isArchiveProcessing || this.isReprocessProcessing;
  }

  static transform(e: OtdsError) {
    let otdsError = new OtdsError();
    otdsError.id = e.id;
    otdsError.nombreDeArchivo = e.nombreDeArchivo;
    otdsError.fecProceso = new Date(e.fecProceso);
    otdsError.origen = e.origen;
    otdsError.nroRemito = e.nroRemito?.toString() ?? null;
    otdsError.ptoEmision = e.ptoEmision;
    otdsError.codDestino = e.codDestino;
    otdsError.tpreError = e.tpreError;
    otdsError.transporte = e.transporte;
    otdsError.error = e.error;
    otdsError.vinLetras = e.vinLetras;
    otdsError.vinNumeros = e.vinNumeros;
    otdsError.esReprocesado = e.esReprocesado;
    otdsError.vin = (e.vinLetras ?? '') + (e.vinNumeros ?? '');
    otdsError.lineNum = e.lineNum;
    otdsError.canBeReprocessed = e.canBeReprocessed;

    return otdsError;
  }
}
